<template>
  <div class="search-bar-container">
    <input 
        class="search-bar"
        :placeholder="placeholderText"
        type="text"
        v-model="searchText"
        @input.stop="delaySearch">
    <small v-if="searchText" class="clear-search float-right" @click.stop="clearSearch">clear search</small>
    <div v-if="searchError" class="error-message">{{searchError}}</div>
  </div>
</template>

<script>
  export default {
    props: {
      placeholderText: {
        default: 'search',
        type: String,
      },
      searchLimit: {
        default: 150,
        type: Number,
      },
      searchTerm: String,
    },

    name: 'SearchBar',

    data() {
      return {
        delayedSearch: null,
        searchError: null,
        searchText: null,
      }
    }, 

    methods: {
      clearSearch() {
        this.searchText = null
        this.searchError = null
        this.$emit('clearSearch')
      },

      delaySearch() {
        clearTimeout(this.delayedSearch)
        this.delayedSearch = setTimeout(() => this.validateSearch(), 500)
      },

      validateSearch() {
        this.searchText = this.searchText.replace(/<[^>]*>/g,'').trim()
        const overSearchLimit = this.searchText && this.searchText.length >= this.searchLimit
        if (overSearchLimit) {
          this.searchError = `search must be less than ${this.searchLimit} characters`
        } else {
          this.$emit('getSearchResult', this.searchText)
          this.searchError = null
        }
      }
    },

    created() {
      this.searchText = this.searchTerm || null
    },

    watch: {
      searchTerm: function() {
        if (this.searchTerm) { this.searchText = this.searchTerm }
      },
    },
  }
</script>